import ComponentsFactory from 'foundation/components-factory';
import RightHeaderLinkItem from './js/right-header-link-item.component';

ComponentsFactory.getInstance().define('right-header-link-item', RightHeaderLinkItem);
